/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MachineFile from './MachineFile';

/**
 * The MachineFileRevision model module.
 * @module model/MachineFileRevision
 * @version 0.0.1
 */
class MachineFileRevision {
    /**
     * Constructs a new <code>MachineFileRevision</code>.
     * @alias module:model/MachineFileRevision
     */
    constructor() { 
        
        MachineFileRevision.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MachineFileRevision</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MachineFileRevision} obj Optional instance to populate.
     * @return {module:model/MachineFileRevision} The populated <code>MachineFileRevision</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MachineFileRevision();

            if (data.hasOwnProperty('revision')) {
                obj['revision'] = ApiClient.convertToType(data['revision'], 'Number');
            }
            if (data.hasOwnProperty('machine_file_data')) {
                obj['machine_file_data'] = MachineFile.constructFromObject(data['machine_file_data']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MachineFileRevision</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MachineFileRevision</code>.
     */
    static validateJSON(data) {
        // validate the optional field `machine_file_data`
        if (data['machine_file_data']) { // data not null
          MachineFile.validateJSON(data['machine_file_data']);
        }

        return true;
    }


}



/**
 * @member {Number} revision
 */
MachineFileRevision.prototype['revision'] = undefined;

/**
 * @member {module:model/MachineFile} machine_file_data
 */
MachineFileRevision.prototype['machine_file_data'] = undefined;






export default MachineFileRevision;

